import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Tooltip, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useChargebackDetailsModel } from "./chargebackDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { DetailType, IServiceNatureCodeType } from "@/types/ScmEnums";
import { IItemDetailList } from "../../chargebackType";
import { repairFormatNum, formatNum, formatIntPoint } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import useVrmModel from "@/model/vrmModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { roleColumnModel } from "@/utils/roleColumn";

export const ItemTableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { temporaryObj, setTemporaryid } = useVrmModel();
    const { getSettlementParty } = useGlobalModel();
    const {
        detailAddForm,
        setItemModel,
        detailEditForm,
        detailItemAddList, setDetailItemAddList,
        detailItemAddDataRowKeys, setDetailItemAddDataRowKeys,
        setDetailItemAddDataRow,
        detailItemEditList, setDetailItemEditList,
        detailItemEditDataRowKeys, setDetailItemEditDataRowKeys,
        setDetailItemEditDataRow,
        detailItemLookList,
        detailItemDetailList,
        setTopButsControl,

    } = useChargebackDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onTemporary = () => {
        setTemporaryid(new Date().getTime().toString())
        mode === "add" ? setDetailItemAddList([...detailItemAddList, temporaryObj]) : setDetailItemEditList([...detailItemEditList, temporaryObj])
    }
    const title = <>
        <span>维修项目</span>
        {/* <Tooltip placement="topLeft" title="新增临时项目">
            <FontIcon type="icon-linshibiaoge" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={() => onTemporary()}
            />
        </Tooltip> */}
    </>
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_RETURN_SETTLE || detailEditForm.status === DictCodeEnmu.MAINTENANCE_RETURN_IO || detailEditForm.status === "maintenance.return.paying")) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_R_ED_ADD_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={async () => {
                        // setItemModel(true)
                        if (mode === "add") {

                            let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailEditForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                            if (!(customerCode && customerName && payType && settlementPartyCode)) {
                                message.warning("请补全客户名称或结算类型或结算方")
                                return false
                            }
                            setItemModel(true)
                        } else {
                            setItemModel(true)
                        }
                    }}
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                >新增项目</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_R_ED_DEL_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailItemDetailList(mode)}
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                >删除项目</Button>
            </YhAuth>
        </>}
    </>;
    const itemTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修项目",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setItemModel(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const removeItem = (record: IItemDetailList) => {
        detailItemDetailList(mode, record)
    }
    const itemColumn = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '项目名称',
            width: 140,
            dataIndex: 'itemName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHour',
            editable: isMaterialModel()
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'itemAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            // }, {
            //     title: '原单小计',
            //     width: 100,
            //     dataIndex: 'originalAmount',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: isMaterialModel()
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeItem(record)}
                />
        }
    ];

    const typeItemList = {
        "add": [...detailItemAddList],
        "edit": [...detailItemEditList],
        "look": [...detailItemLookList],
    }
    const newSelectItemColums = () =>
        itemColumn.map((col: any, index) => {
            let disaBled = col.dataIndex === "itemCode" || col.dataIndex === "itemName"
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: disaBled ? record.temporary && mode !== "look" : col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    // allowClear: col.allowClear,
                    mode: col.mode,
                    handleSave: handleItemSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderReturn", "roleCodes": roles };
        return getRoleColumns("orderReturn", "维修项目", newSelectItemColums(), params);
    }, [roles, typeItemList[mode], itemColumn]);

    const handleItemSave = (row: IItemDetailList) => {
        let { workHour, price, discountRate, originalNum } = row;
        const newServiceNatureCode = mode === "add" ? detailAddForm.serviceNatureCode : detailEditForm.serviceNatureCode;

        workHour = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(workHour) : +formatNum(workHour); //工时
        price = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(price) : +formatNum(price); //工时费
        // discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        if (workHour > originalNum) {
            workHour = originalNum as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时，不能大于原单的工时');
        }
        let newRow = {
            ...row,
            price,
            workHour,
            discountRate,
            itemAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(workHour * price) : +formatNum(workHour * price),
            receivableAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((workHour * price * discountRate) / 100) : +formatNum((workHour * price * discountRate) / 100),
        }
        let newData = mode === "edit" ? detailItemEditList : detailItemAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailItemEditList([...newData]) : setDetailItemAddList([...newData])
        setTopButsControl(true)

    }
    //设置维修项目选中的行和数据
    const setTypeItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeItemDetailDataRow = async (selectedRows: IItemDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRow(selectedRows)
        }
    }

    return (
        <YhBox title={title} rightChildren={action} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailItemAddDataRowKeys : detailItemEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetailList[]) => {
                            setTypeItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeItemDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeItemDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeItemList[mode] as IItemDetailList[]}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}